import { useState, useEffect } from 'react';

const WHATSAPP_LINK = "https://chat.whatsapp.com/ILssAdPpUi4E066RBsaGtf"
const STORAGE_KEY = "wa_prompt_dismissed_date";

function getTodayString() {
  return new Date().toISOString().slice(0, 10); // YYYY-MM-DD
}

export function WhatsAppPromptModal({ isLoggedIn }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isLoggedIn) return;
    const dismissedDate = localStorage.getItem(STORAGE_KEY);
    if (dismissedDate !== getTodayString()) {
      setVisible(true);
    }
  }, [isLoggedIn]);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, getTodayString());
    setVisible(false);
  };

  const handleJoin = () => {
    window.open(WHATSAPP_LINK, "_blank", "noopener,noreferrer");
    dismiss();
  };

  if (!visible) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h3 style={{ marginTop: 0 }}>Join our WhatsApp group!</h3>
        <p>
          Get live updates, discuss gameweeks, and chat with other managers.
          Join the FPL365 WhatsApp community — it only takes a second.
        </p>
        <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
          <button onClick={handleJoin} style={primaryBtn}>Join WhatsApp Group</button>
          <button onClick={dismiss} style={secondaryBtn}>Not now</button>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
  display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
};
const modalStyle = {
  background: "#fff", borderRadius: 12, padding: 24, maxWidth: 380,
  width: "90%", boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
};
const primaryBtn = {
  flex: 1, padding: "10px 16px", background: "#25D366", color: "#fff",
  border: "none", borderRadius: 8, fontWeight: 600, cursor: "pointer",
};
const secondaryBtn = {
  flex: 1, padding: "10px 16px", background: "#f0f0f0", color: "#333",
  border: "none", borderRadius: 8, cursor: "pointer",
};